const tiendaSelect = document.getElementById('tiendaSelect');
const tiendasList = document.getElementById('tiendasList');
const tiendaItems = document.querySelectorAll('.tienda-item');
const tiendaImages = document.querySelectorAll('.tienda-image');

function activarTienda(tiendaId) {
    tiendaItems.forEach(item => item.classList.remove('is-active'));
    tiendaImages.forEach(img => img.classList.remove('is-active'));

    const selectedItem = document.querySelector(`[data-tienda="${tiendaId}"]`);
    if (selectedItem) {
        if (selectedItem.classList.contains('tienda-item')) {
            selectedItem.classList.add('is-active');
            
            selectedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        const selectedImage = document.querySelector(`.tienda-image[data-tienda="${tiendaId}"]`);
        if (selectedImage) {
            selectedImage.classList.add('is-active');
        }
    }
}

tiendaSelect.addEventListener('change', function() {
    const selectedValue = this.value;
    if (selectedValue) {
        activarTienda(selectedValue);
    }
});

tiendaItems.forEach(item => {
    item.addEventListener('click', function() {
        const tiendaId = this.getAttribute('data-tienda');
        activarTienda(tiendaId);
        
        tiendaSelect.value = tiendaId;
    });
});

document.querySelectorAll('.link-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
        e.stopPropagation();
    });
});